import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@oasisprotocol/ui-library/src/components/typography'
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { ConsensusCard, ConsensusFallbackCard } from './ConsensusCard'
import { SapphireCard, SapphireFallbackCard } from './SapphireCard'

export const Ecosystem: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <Typography variant="h3"> {t('home.ecosystem.title')}</Typography>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
        <ErrorBoundary light fallbackContent={<SapphireFallbackCard />}>
          <SapphireCard />
        </ErrorBoundary>
        <ErrorBoundary light fallbackContent={<ConsensusFallbackCard />}>
          <ConsensusCard />
        </ErrorBoundary>
      </div>
    </div>
  )
}
